import { BaseMutations } from '@/store/base-mutations';
import { PaginationProps, TableOptions } from '@/types';
import { default_staffs_filters, default_staffs_table_filters } from '@/modules/courses-requests/services';
import CoursesRequestsState from './state';
import { CoursesRequests } from '../types';

export default class CoursesRequestsMutations extends BaseMutations<CoursesRequestsState> {
  SET_COURSES_REQUESTS(courses: CoursesRequests.Item[]) {
    this.state.courses_requests = courses;
  }

  SET_COURSES_REQUEST(courses_request: CoursesRequests.Item) {
    this.state.courses_request = courses_request;
    this.state.request_need_update = false;
  }

  SET_COURSES_REQUEST_STATUSES(statuses: string[]) {
    this.state.statuses = statuses;
  }

  TOGGLE_COURSES_REQUESTS_LOADING(toggle: boolean) {
    this.state.loading = toggle;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof CoursesRequests.RequestsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  TOGGLE_NEED_UPDATE(toggle: boolean) {
    this.state.need_update = toggle;
  }

  TOGGLE_REQUEST_NEED_UPDATE(toggle: boolean) {
    this.state.request_need_update = toggle;
  }

  // ----------------------------------------Courses----------------------------------------

  TOGGLE_COURSES_LOADING(toggle: boolean) {
    this.state.courses.loading = toggle;
  }

  TOGGLE_COURSES_NEED_UPDATE(toggle: boolean) {
    this.state.courses.need_update = toggle;
  }

  SET_COURSES({ request_id, items }: { request_id: number, items: CoursesRequests.Course[] }) {
    this.state.courses.request_id = request_id;
    this.state.courses.items = items;
  }

  CLEAR_COURSES() {
    this.state.courses.request_id = 0;
    this.state.courses.items = [];
    this.state.courses.table_options.page = 1;
    this.state.courses.pagination_props.current_page = 1;
  }

  SET_COURSES_TABLE_OPTIONS(opts: TableOptions) {
    this.state.courses.table_options = opts;
  }

  UPD_COURSES_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.courses.table_options[key] = value;
  }

  UPD_COURSES_PAGINATION_FIELDS(fields: PaginationProps) {
    Object.keys(fields).forEach((key: keyof PaginationProps) => {
      this.state.courses.pagination_props[key] = fields[key];
    });
  }

  UPD_COURSES_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.courses.pagination_props[key] = value;
  }

  // ----------------------------------------Staffs----------------------------------------

  SET_STAFFS({ request_id, filters, items }: { request_id: number, filters: CoursesRequests.StaffsTableFilters, items: CoursesRequests.Staff[] }) {
    this.state.staffs.request_id = request_id;
    this.state.staffs.items = items;

    if (filters.staffs.length > 0 || filters.courses.length > 0) {
      this.state.staffs.table_filters = filters;
    }
  }

  CLEAR_STAFFS() {
    this.state.staffs.filters = default_staffs_filters();
    this.state.staffs.table_filters = default_staffs_table_filters();
    this.state.staffs.request_id = 0;
    this.state.staffs.items = [];
    this.state.staffs.table_options.page = 1;
    this.state.staffs.pagination_props.current_page = 1;
  }

  UPD_STAFFS_FILTER_KEY({ key, value }: { key: keyof CoursesRequests.StaffsFilters, value: unknown }) {
    this.state.staffs.filters[key] = value;
  }

  TOGGLE_STAFFS_LOADING(toggle: boolean) {
    this.state.staffs.loading = toggle;
  }

  TOGGLE_STAFFS_NEED_UPDATE(toggle: boolean) {
    this.state.staffs.need_update = toggle;
  }

  SET_STAFFS_TABLE_OPTIONS(opts: TableOptions) {
    this.state.staffs.table_options = opts;
  }

  UPD_STAFFS_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.staffs.table_options[key] = value;
  }

  UPD_STAFFS_PAGINATION_FIELDS(fields: PaginationProps) {
    Object.keys(fields).forEach((key: keyof PaginationProps) => {
      this.state.staffs.pagination_props[key] = fields[key];
    });
  }

  UPD_STAFFS_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.staffs.pagination_props[key] = value;
  }

  // ----------------------------------------History----------------------------------------

  SET_HISTORY({ request_id, items }: { request_id: number, items: CoursesRequests.HistoryItem[] }) {
    this.state.history.request_id = request_id;
    this.state.history.items = items;
  }

  CLEAR_HISTORY() {
    this.state.history.request_id = 0;
    this.state.history.items = [];
    this.state.history.table_options.page = 1;
    this.state.history.pagination_props.current_page = 1;
  }

  TOGGLE_HISTORY_LOADING(toggle: boolean) {
    this.state.history.loading = toggle;
  }

  TOGGLE_HISTORY_NEED_UPDATE(toggle: boolean) {
    this.state.history.need_update = toggle;
  }

  UPD_HISTORY_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.history.table_options[key] = value;
  }

  SET_HISTORY_TABLE_OPTIONS(opts: TableOptions) {
    this.state.history.table_options = opts;
  }

  UPD_HISTORY_PAGINATION_FIELDS(fields: PaginationProps) {
    Object.keys(fields).forEach((key: keyof PaginationProps) => {
      this.state.history.pagination_props[key] = fields[key];
    });
  }

  UPD_HISTORY_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.history.pagination_props[key] = value;
  }

  UPD_ALL_SELECTED_COURSES(value: boolean) {
    this.state.courses_requests = this.state.courses_requests.map((item) => ({
      ...item,
      selected: value,
    }));
  }

  UPD_SELECTED_COURSES({ item, value }: { item: CoursesRequests.Item, value: boolean }) {
    if (!item) {
      return;
    }

    this.state.courses_requests = this.state.courses_requests.map((request) =>
      (request.id === item.id ? { ...request, selected: value } : request));
  }
}
